import React from 'react';

import { Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { TabEmptyState } from './TabEmptyState';

export const OverviewCardGroup: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => (
  <Stack gap={4} align="stretch">
    <Text
      size="xs"
      color="tertiary"
      weight="semibold"
      className="-mb-1 px-4 tracking-wide uppercase"
    >
      {title}
    </Text>
    {children}
  </Stack>
);

/**
 * Overview-tab shell. Cards are composed in by the router (children) rather
 * than imported here — the FHIR feature libs consume `@eluve/fhir-data`,
 * which depends on this lib, so importing them from here would cycle.
 */
export const PatientOverviewTab: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const { t } = useTranslation();
  if (!children) {
    return (
      <TabEmptyState
        title={t('patients.tabs.overview')}
        description={t('patients.profile.overviewEmptyDescription')}
      />
    );
  }
  return (
    <Stack gap={6} align="stretch">
      {children}
    </Stack>
  );
};
